import React, { Component } from "react";
import { connect } from "react-redux";
import { registerClick } from "../actions/application_actions";
import { createCookie, readCookie } from "../helpers/cookie_helper";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import LoanSelector from "./LoanSelector_container";
import YouTube from "react-youtube";
import { withRouter } from "react-router";

class CreditBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = { clicked: false };
    this.video = React.createRef();
  }

  componentDidMount() {
    if (this.props.utm.source === "remitly") {
      let cookie = readCookie("credit-builder-remitly");
      let type;
      if (cookie) {
        type = "cb-remitly_r";
      } else {
        type = "cb-remitly";
        cookie = new Date();
        createCookie("credit-builder-remitly", cookie);
      }
      this.props.registerClick(null, null, type, cookie);
    }

    window.addEventListener("beforeunload", this.unload);
  }

  unload = (e) => (e.returnValue = "Leave changes unsaved?");

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.unload);
  }

  scrollToTop = () => {
    window.scrollTo({ top: 0 });
    return false;
  };

  handleVideoReady = (e) => {
    const search = new URLSearchParams(this.props.location.search);
    if (search.get("video")) {
      this.video.current.scrollIntoView({ behavior: "smooth" });
      e.target.playVideo();
    }
  };

  render() {
    let button = true ? (
      <div
        onClick={() => {
          this.setState({ clicked: true });
        }}
        className="button primary"
        id="cb_submit"
      >
        Apply Now
      </div>
    ) : (
      <p>
        We are currently working with your local government to bring the Credit
        Builder product to your community by December 2020. Please feel free to
        send us an email at service@figloans.com with any questions.
      </p>
    );

    return (
      <article className="article-main">
        <Helmet>
          <title>Credit Builder | Fig Loans</title>
          <link
            rel="canonical"
            href="https://www.figloans.com/credit-builder"
          />
          <meta
            name="description"
            content="Fig credit builder loans offer a low cost way to start building positive credit history"
          />
          <meta
            property="og:description"
            content="Fig credit builder loans offer a low cost way to start building positive credit history"
          />
        </Helmet>
        <section
          className="section-panel bg-grey section-welcome"
          id="cb-welcome"
        >
          <div className="content-container">
            <div className="content group">
              <div className="column left">
                <h1>Credit Builder</h1>
                <p className="large">
                  <span className="opaque">
                    {"Fig's"} credit builder savings account offers a
                  </span>{" "}
                  low cost{" "}
                  <span className="opaque">way to begin building a</span>{" "}
                  positive credit history. <br />
                  <br />
                  <span className="opaque">{"There's"} a</span> one-time fee{" "}
                  <span className="opaque">
                    to open the account and then 12 monthly payments to
                  </span>{" "}
                  build your credit.
                  <br />
                  <br /> {"That's"} 1 payment for us and 12 for you!
                  <span />
                </p>
              </div>

              <aside className="aside-loan-calculator">
                <div className="content">
                  <h3>Begin building your credit history today!</h3>
                  <hr />
                  <div style={{ display: "block" }}>
                    {!this.state.clicked ? (
                      <div>
                        <div id="cb-aside-1-text">
                          <h4 style={{ color: "black" }}>Please read: </h4>
                          <p>
                            A credit builder loan is a reverse loan, meaning
                            that you make payments into a savings account over
                            the course of one year and receive funds at THE END
                            of the year. Over the year, {"we'll"} report on-time
                            payments to all three credit bureaus and build your
                            credit history!
                            <br />
                            <br />
                            If you are looking for funds immediately, please
                            apply for a <Link to="/">traditional loan</Link>.
                          </p>
                          <p>
                            When picking your Credit Builder amount, make sure
                            to pick a manageable payment size. {"It's"} more
                            important to show consistent payments than erratic
                            large payments.
                          </p>
                        </div>
                        {button}
                      </div>
                    ) : (
                      <LoanSelector 
                        edit={false} 
                        product={"credit_builder"}
                        entryPoint="credit_builder"
                        flowContext="new_application"
                      />
                    )}

                    <div className="clear" />
                  </div>
                </div>
              </aside>
            </div>
            <div className="compare">
              <div className="content group">
                <p>See how it works...</p>
              </div>
            </div>
          </div>
        </section>

        <section className="section-panel bg-white" id="section-features">
          <img
            src="https://s3.us-west-2.amazonaws.com/figloans-static-images/credit_builder/arrow.png"
            className="arrow"
            alt="Arrow"
          />
          <div className="content-container credit-journey">
            <h2 className="center">Your Credit Journey</h2>
            <div className="center">
              <img
                src="https://s3.us-west-2.amazonaws.com/figloans-static-images/credit_builder/credit_score.png"
                alt="Credit Journey"
              />
            </div>
          </div>

          <div className="panel-grey">
            <div className="content-container">
              <div className="content group" id="compare-cb">
                <h4 className="center">
                  {"How's"} a Credit Builder different from a traditional loan?
                </h4>
                <div className="column half">
                  <div className="diagram">
                    <img
                      src="https://s3.us-west-2.amazonaws.com/figloans-static-images/credit_builder/credit_builder_flow.png"
                      alt="Transparent Terms"
                    />
                  </div>
                  <h3>Credit Builder</h3>
                  <p>
                    Upon approval and payment of the one-time account opening
                    fee, the lender sends your funds to a 3rd party bank to hold
                    for you. You make payment similar to a traditional loan.
                    Upon completion of your loan, the lender releases the funds
                    from the 3rd party to you.
                  </p>
                </div>
                <div className="column half">
                  <div className="diagram">
                    <img
                      src="https://s3.us-west-2.amazonaws.com/figloans-static-images/credit_builder/traditional_flow.png"
                      alt="Credit Reporting"
                    />
                  </div>
                  <h3>Traditional Loan</h3>
                  <p>
                    Upon approval, the lender sends your funds directly to you.
                    Afterwards you make payments until your loan is paid off.
                    Nothing occurs upon the completion of your loan.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="panel-white">
            <h4 id="video-header">Learn More!</h4>
            <div className="video-wrapper">
              <div className="center video" ref={this.video}>
                <YouTube
                  videoId="QipG_Hsq0c8"
                  opts={{
                    playerVars: { start: 0 },
                    width: "100%",
                    margin: "0px 0px 0px 0px",
                  }}
                  className="video"
                  onReady={this.handleVideoReady}
                />
              </div>
            </div>
            <div className="clear" />
          </div>
        </section>

        <section className="section-panel bg-beige" id="section-features">
          <div className="content-container">
            <div className="panel-grey">
              <div className="mission">
                <div className="mission-text">
                  <h4>Frequently Asked Questions </h4>
                  <p>
                    Not about to find your credit builder answer below? Email us
                    at{" "}
                    <a
                      href="mailto:service@figloans.com?Subject=Question%20about%20Fig"
                      target="_top"
                    >
                      service@figloans.com
                    </a>
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="faq-links">
                  <a href="#canicancelearly">Can I close my loan early?</a>
                  <br />
                  <a href="#aretherelatefees">Are there late fees?</a>
                  <br />
                  <a href="#whatistheaccountopeningfee">
                    What is the account opening fee?
                  </a>
                  <br />
                  <a href="#ireallyneedmoneytoday">
                    I really need money today!
                  </a>
                  <br />
                  <a href="#howmuchwillmycreditscoreincrease">
                    How much will my credit score increase?
                  </a>
                  <br />
                  <a href="#whodoyoureportto">Who do you report to?</a>
                  <br />
                  <a href="#whatdoesthe3rdpartydowithmyfunds">
                    What does the 3rd party do with my funds?
                  </a>
                  <br />
                  <a href="#whytakeoutacreditbuilderoveratraditionalloan">
                    Why take out a credit builder over a traditional loan?
                  </a>
                  <br />
                  <a href="#whydoyougivemyfundstoa3rdpartybank">
                    Why do you give my funds to a 3rd party bank?
                  </a>
                  <br />
                  <a href="#whydoineedtobeanexistingcustomer">
                    Why do I need to be an existing customer?
                  </a>
                  <br />
                </div>
              </div>
              <div className="row">
                <div className="faq">
                  <h4 id="canicancelearly">Can I close my loan early?</h4>
                  <p className="faq">
                    Yes! If you choose to close your account, we authorize the
                    3rd party to disperse the loan funds to you minus any
                    payments you {"haven't"} made plus the non-refundable
                    account opening fee. For example, suppose you borrowed a
                    $1200 12-month monthly-payment credit builder at 0% (to make
                    the math easier) and want to cancel your loan after the 10th
                    payment. Upon cancellation, we authorize the 3rd party bank
                    to send you the loan amount ($1200) - the principal you{" "}
                    {"didn't"}
                    make (2 payments * $100 principal per payment) or a $1,000.
                  </p>
                  <a onClick={this.scrollToTop}>back to top</a>
                  <div className="clear" />
                </div>
              </div>
              <div className="row">
                <div className="faq">
                  <h4 id="aretherelatefees">Are there late fees?</h4>
                  <p className="faq">
                    We do not charge late fees! If at any point you have a
                    payment that is about to become 30 days delinquent, Fig will
                    close the loan before it has a chance to hurt your credit
                    and refund you the principal that {"you've"} paid in so far.
                    The only thing we take out is the interest that has accrued
                    on the late payment, so that we can legally report the
                    account as closed and not delinquent.
                  </p>
                  <a onClick={this.scrollToTop}>back to top</a>
                  <div className="clear" />
                </div>
              </div>
              <div className="row">
                <div className="faq">
                  <h4 id="whatistheaccountopeningfee">
                    What is the account opening fee?
                  </h4>
                  <p className="faq">
                    This is a one-time, non-refundable fee that you pay at the
                    beginning of the loan for us to open the account on your
                    credit report. We charge this fee because this is the part
                    that requires the most work on our part. This also allows us
                    to give you an interest rate below 4%! Also, once the
                    account is open, every payment you make increases your
                    score!
                  </p>
                  <a onClick={this.scrollToTop}>back to top</a>
                  <div className="clear" />
                </div>
              </div>

              <div className="row">
                <div className="faq">
                  <h4 id="ireallyneedmoneytoday">I really need money today!</h4>
                  <p className="faq">
                    We completely understand. You want to apply for a
                    traditional Fig loan vs the credit builder. Please click{" "}
                    <Link to="/">here</Link>.
                  </p>
                  <a onClick={this.scrollToTop}>back to top</a>
                  <div className="clear" />
                </div>
              </div>
              <div className="row">
                <div className="faq">
                  <h4 id="howmuchwillmycreditscoreincrease">
                    How much will my credit score increase?
                  </h4>
                  <p className="faq">
                    This is a surprisingly difficult question. There are a
                    number of major "credit scores" lenders use and what feels
                    like a new one every year. We do not control how these
                    scores are calculated. The only thing we can promise is to
                    faithfully report your payments to build your credit
                    history, the data lenders use to calculate your scores.
                  </p>
                  <a onClick={this.scrollToTop}>back to top</a>
                  <div className="clear" />
                </div>
              </div>
              <div className="row">
                <div className="faq">
                  <h4 id="whodoyoureportto">Who do you report to?</h4>
                  <p className="faq">
                    We report to TransUnion, Equifax and Experian.
                  </p>
                  <a onClick={this.scrollToTop}>back to top</a>
                  <div className="clear" />
                </div>
              </div>
              <div className="row">
                <div className="faq">
                  <h4 id="whatdoesthe3rdpartydowithmyfunds">
                    What does the 3rd party do with my funds?
                  </h4>
                  <p className="faq">
                    Nothing! It just sits in bank account until you complete or
                    cancel your loan. We know {"it's"} a leap of faith to make
                    payments without receiving your funds first. {"That's"} why
                    you can cancel your loan at any time and receive the
                    pro-rated portion of your principal.
                  </p>
                  <a onClick={this.scrollToTop}>back to top</a>
                  <div className="clear" />
                </div>
              </div>
              <div className="row">
                <div className="faq">
                  <h4 id="whytakeoutacreditbuilderoveratraditionalloan">
                    Why take out a credit builder over a traditional loan?
                  </h4>
                  <p className="faq">
                    Our research has shown that longer larger loans have a
                    greater impact on your credit score. Our traditional loan is
                    not designed be large or long term. Imagine a $1,000 dollar
                    loan at 190% APR over 12 months. {"That's"} almost $1,300
                    dollars in fees! {"We're"} not that kind of lender and we{" "}
                    {"don't"} think you should pay through the nose to build
                    your credit.
                  </p>
                  <a onClick={this.scrollToTop}>back to top</a>
                  <div className="clear" />
                </div>
              </div>
              <div className="row">
                <div className="faq">
                  <h4 id="whydoyougivemyfundstoa3rdpartybank">
                    Why do you give my funds to a 3rd party bank?
                  </h4>
                  <p className="faq">
                    A large part of your fees in a traditional loan goes to pay
                    for non-paying borrowers. By sending the funds to a 3rd
                    party to hold, there is no risk of non-payment, which saves
                    everyone money.
                  </p>
                  <a onClick={this.scrollToTop}>back to top</a>
                  <div className="clear" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </article>
    );
  }
}

const mapStateToProps = (state) => ({
  utm: state.entities.utm,
});

const mapDispatchToProps = (dispatch) => ({
  registerClick: (user_id, loan_id, click_type, comments) =>
    dispatch(registerClick(user_id, loan_id, click_type, comments)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreditBuilder));
